/**
 * Scene backgrounds for Image / random appearance.
 * Mirrors android-word-wheel-quest `src/lib/bgAssets.js` → `public/bg_images/word-wheel`.
 */

const PUBLIC = process.env.PUBLIC_URL || "";

/** All scene backgrounds available for the Image appearance. */
export const BG_IMAGE_CATALOG = {
    beach: `${PUBLIC}/bg_images/word-wheel/beach.png`,
    classroom: `${PUBLIC}/bg_images/word-wheel/classroom.png`,
    deep_sea: `${PUBLIC}/bg_images/word-wheel/deep_sea.png`,
    flowers: `${PUBLIC}/bg_images/word-wheel/flowers.png`,
    island: `${PUBLIC}/bg_images/word-wheel/island.png`,
    mountain: `${PUBLIC}/bg_images/word-wheel/mountain.png`,
    road: `${PUBLIC}/bg_images/word-wheel/road.png`,
    tropical_island: `${PUBLIC}/bg_images/word-wheel/tropical_island.png`,
    urban: `${PUBLIC}/bg_images/word-wheel/urban.png`,
    village: `${PUBLIC}/bg_images/word-wheel/village.png`,
};

/** Stable alphabetical order so the 3-day rotation stays deterministic. */
export const BG_IMAGE_IDS = Object.keys(BG_IMAGE_CATALOG).sort();

const DAYS_PER_SCENE = 3;
const MS_PER_DAY = 86400000;

/** Epoch-day bucket: each scene stays visible for {@link DAYS_PER_SCENE} days. */
export function getScenePeriodIndex(date = new Date()) {
    const utcDay = Math.floor(
        Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()) / MS_PER_DAY
    );
    return Math.floor(utcDay / DAYS_PER_SCENE);
}

export function getScenePeriodKey(date = new Date()) {
    return `P${getScenePeriodIndex(date)}`;
}

/**
 * Returns `{ id, url, period, periodKey }` for the current 3-day window.
 * Cycles through every catalog image in order.
 */
export function resolveSceneBackground(date = new Date()) {
    const period = getScenePeriodIndex(date);
    const id = BG_IMAGE_IDS[period % BG_IMAGE_IDS.length] || BG_IMAGE_IDS[0];
    return {
        id,
        url: BG_IMAGE_CATALOG[id],
        period,
        periodKey: getScenePeriodKey(date),
    };
}

/** Human labels for settings theme previews. */
export const BG_IMAGE_LABELS = {
    beach: "Beach",
    classroom: "Classroom",
    deep_sea: "Deep sea",
    flowers: "Flowers",
    island: "Island",
    mountain: "Mountain",
    road: "Road",
    tropical_island: "Tropical island",
    urban: "Urban",
    village: "Village",
};
